import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737e0468"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-service-search" }

import { computed, PropType } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import BaseAutocomplete from '@/components/BaseAutocomplete.vue'
import { debounce } from 'lodash'
import { useRoutePlanningServicesMutation } from '@/queries/public/services'
import { Option } from '@/models/shared.model'
import { useFilterStore } from '@/store/filter'
import { ROUTE_PLANNER_FILTERS } from '@/enums/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteServiceSearch',
  props: {
  services: {
    type: Array as PropType<PublicService[]>,
    required: true,
  },
},
  emits: ['onChange', 'onSelect'],
  setup(__props, { emit: emits }) {

const props = __props



const { routeServiceFilter, updateRouteServiceFilters } = useFilterStore()

const debouncedFetchServices = debounce(handleFetchServices, 400)
const { mutateAsync: fetchServices, isLoading } =
  useRoutePlanningServicesMutation()

const options = computed<Option[]>(() =>
  props.services.map((service) => ({
    key: service.id,
    label: `${service.name} (${service.company_name})`,
  })),
)

async function handleFetchServices() {
  try {
    const searchResults = await fetchServices(routeServiceFilter.filters)
    emits('onChange', searchResults)
  } catch (e) {
    console.error(e)
  }
}

const handleSelect = async (option: Option) => {
  const selectedService = props.services.find(
    (service) => service.id === option.key,
  )
  if (selectedService) {
    emits('onSelect', selectedService)
    updateRouteServiceFilters('', ROUTE_PLANNER_FILTERS.SEARCH)
    handleFetchServices()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseAutocomplete, {
      modelValue: _unref(routeServiceFilter).filters.search,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_unref(routeServiceFilter).filters.search) = $event)),
        _cache[2] || (_cache[2] = 
        (value) =>
          _unref(updateRouteServiceFilters)(value, _unref(ROUTE_PLANNER_FILTERS).SEARCH)
      )
      ],
      options: _unref(options),
      "no-options-label": _ctx.$t('noResults'),
      placeholder: 'Otsi',
      "is-loading": _unref(isLoading),
      name: "clientFinder",
      "icon-left": "magnifying-glass",
      "disable-filtering": true,
      "close-on-select": true,
      onKeyup: _unref(debouncedFetchServices),
      onOptionClick: _cache[1] || (_cache[1] = (value) => handleSelect(value))
    }, null, 8, ["modelValue", "options", "no-options-label", "is-loading", "onKeyup"])
  ]))
}
}

})